<template>
    <v-container fill-height class="mainBackG loginMain">
        <v-layout row wrap>
            <v-flex class="text-xs-center" xs12 lg4 style="margin:auto">

              <div class="Formcard no-shadow pb-5 card-r">

                    <v-form v-model="verification" row class="w-100">
                      <v-flex xs12 md12 pt-0>
                        <v-toolbar flat xs12 class="toolbar pa-0 mb-3">
                          <div  class="btn-tool text-xs-right">
                            <router-link to="`/signup`" class="aBtn"><v-icon class="textColor">keyboard_arrow_left</v-icon></router-link>
                          </div>
                          <v-spacer></v-spacer>
                          <v-toolbar-title>
                            <h2 class="textColor text-xs-center title">Verification</h2>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items class="hidden-sm-and-down">
                          </v-toolbar-items>
                        </v-toolbar>
                        <!-- <img class = "logo" src="../../assets/logo.png"/>
                        <h1 class="headline font-weight-medium">Reset password</h1> -->

                      </v-flex>

                            <v-layout wrap class="mb-5 pb-5 pt-130">
                                <!-- <v-flex xs12 md12 class="text-xs-right" py-0 my-0>
                                </v-flex> -->
                              <span class="font-weight-regular f-14 grey--text" >Enter your email verification code</span>
                              <v-flex xs12 sm12>
                                    <v-text-field
                                    solo
                                    label="Code"
                                      v-model="code" required></v-text-field>
                                </v-flex>

            <v-flex xs12 sm12 pb-0 class="display-grid">
                <v-btn class="h-50p ma-0 text-white mainBackG no-shadow card-r" color="white" :disabled="!verification" :to="``">Confirm</v-btn>
            </v-flex>

        </v-layout>

    </v-form>
</div>
</v-flex>
</v-layout>
</v-container>
</template>

<script>
/* eslint-disable */
export default {
  name: "ResetPassword",
  data: () => ({
    verification: false,
    code: ""
  })
};
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Verification.vue